<div #eiaGasConsumption>

</div>



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/gas-consumption/gas-consumption.component.html